import apiClient from "./client";

export const getAdminCourses = async () => {
  const response = await apiClient.get("/courses/admin");
  return response.data;
};

export const createAdminCourse = async (payload) => {
  const response = await apiClient.post("/courses/admin", payload);
  return response.data;
};

export const updateAdminCourse = async ({ id, payload }) => {
  const response = await apiClient.put(`/courses/admin/${id}`, payload);
  return response.data;
};

export const deleteAdminCourse = async ({ id }) => {
  await apiClient.delete(`/courses/admin/${id}`);
};
